export default "__VITE_ASSET__BpXibrNy__"